// deepanshu_code

import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate , useParams } from "react-router-dom";
import "../../../assets/AdminCss/admin_users.css";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import AdminModal from "./AdminModal";
import axios from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { AuthContext } from "../../../context/Authcontext";
import api from "../../../utils/api";

export const base_url = process.env.REACT_APP_API_URL;

const ChildUsers = () => {

  const { code } = useParams();
  const navigate = useNavigate();  
  const [activeList, setActiveList] = useState(0);
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [modal, setModal] = useState({ action: null, id: null });
  const [permit,setPermit]= useState([]);
  const [users, setUsers] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const { getRoles }= useContext(AuthContext);
  const [money, setMoney]= useState();
  const [hist, setHist]= useState({});
  const [originalUsers, setOriginalUsers] = useState(); // Store original data
  const [searchText, setSearchText] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const handleModal = (action, id) => {
    // console.log('dta-id',id, 'action', action);
    setModal({ action: action, id: id });
  };

  const fetchUsers = useCallback(async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await api.get(
       "/api/webapi/admin/memberList",
        {
          withCredentials: true, // ✅ Send cookies with the request
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );
      // console.log('resp',response);

      if (!response?.data.success) console.log('unable to fetch data');
      const data = response.data;
      const datas = data.datas;

    //   console.log("Data is " , datas)
    //   console.log("code is ", code)

      const childUsers = datas.filter((user) =>
        user?.invite === code );
      // console.log("child users ", childUsers);
       const money=data?.datas[0];
      // console.log('dta',money);
      setMoney(money.money);
      setUsers(childUsers);
      setOriginalUsers(childUsers);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [code]);

 

  const fetchHist= useCallback(async(req, res)=> {
    try{
      const role= localStorage.getItem('role');
      const auth= localStorage.getItem('auth');
      // console.log('roleee',role);

      const respon= await api.post('/api/webapi/admin/chipHistory',
        {role},
        {
          headers:{
            'content-type':'application/json',
            Authorization:`${auth}`
          }
        }
      )

      // console.log('respp0',respon);
      const data= respon?.data.result;
      // console.log(data);
      if(respon?.data.success){
        setHist(data[0])
      }

    }catch(err){
      console.log(err);
    }
  },[]);

  const fetchRoles= useCallback(async ()=> {
    const auth= localStorage.getItem('admin');
    const role= localStorage.getItem('role');

    try{
      const roles= await getRoles(auth, role);
      let allPermit=[];

      const vall= Object.values(roles[0]);

      const arr= Object.values(vall[0]);

      arr.map((role)=>{
        const permis= Object.values(role);

        permis.map((per)=> {
          const k= Object.values(per);

          k.map((real)=> {
            allPermit.push(real);
          })

        })
      })
      setPermit(allPermit)


    }catch(error){
      console.log('ert',error);
    }
  },[])

  useEffect(() => {
    fetchUsers();
    fetchRoles();
    fetchHist();
  }, [fetchUsers]);

// console.log('perbhyure',permit);

const handleChange = (e) => {
  const searchEle = e.target.value.toLowerCase(); // Convert input to lowercase for case-insensitive search
  setSearchText(searchEle);

  if (searchEle === "") {
    setUsers(originalUsers); // Reset to full data when input is cleared
    return;
  }

  const filteredData = originalUsers?.filter((item) =>
    item.invite.toLowerCase().includes(searchEle) // Case-insensitive search
  );

  // console.log("Filtered Data:", filteredData);
  setUsers(filteredData);
};


// fancy lock
  const toggleLockFancy = async (newStatus, userId) => {
    try {
      const response = await axios.post(
        base_url + '/api/admin/lockFancy',
        { status: newStatus, userId },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      if (response.data.success) {
        toast.success('User Fancy updated successfully');
      } else {
        console.warn('User fancy update failed');
      }
    } catch (error) {
      console.error('Error updating user fancy:', error);
    }
  };


  const toggleLockBet = async (newStatus, userId) => {
    // console.log(userId, newStatus);
    try {
      const response = await axios.post(
        base_url + '/api/admin/lockBet',
        { status: newStatus, userId },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      if (response.data.success) {
        toast.success('User Fancy updated successfully');
      } else {
        console.warn('User fancy update failed');
      }
    } catch (error) {
      console.error('Error updating user fancy:', error);
    }
  };

  



 const toggleLockUser = async (currentStatus, userId) => {
  const newStatus = currentStatus === 1 ? 2 : 1;
  // console.log("Toggling user", userId, "from status", currentStatus, "to", newStatus);

  try {
    const response = await axios.post(base_url + '/api/admin/lockUser',
      { status: newStatus, userId },
      {
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );

    if (response.data.success) {
      console.log('User status updated successfully');
      // Optional: refresh user data here
    } else {
      console.warn('User status update failed');
    }
  } catch (error) {
    console.error('Error updating user status:', error);
  }
};

// console.log('ue',users);
  const handleRefresh = () => {
    // navigate('/admin/users');
    toast.success("Refreshing data...");
    fetchUsers();
  };


  function formateT(params) {
    let result = params < 10 ? "0" + params : params;
    return result;
  }
  function timerJoin(params = "", addHours = 0) {
    let date = "";
    if (params) {
      date = new Date(Number(params));
    } else {
      date = new Date();
    }

    date.setHours(date.getHours() + addHours);

    let years = formateT(date.getFullYear());
    let months = formateT(date.getMonth() + 1);
    let days = formateT(date.getDate());

    let hours = date.getHours() % 12;
    hours = hours === 0 ? 12 : hours;
    let ampm = date.getHours() < 12 ? "AM" : "PM";

    let minutes = formateT(date.getMinutes());
    let seconds = formateT(date.getSeconds());

    return (
      years +
      "-" +
      months +
      "-" +
      days +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds +
      " " +
      ampm
    );
  }


  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (loading) return <p>Loading users...</p>;
  if (error) return <p>Error: {error}</p>;


  return (
    <>
     <div className="wrapper">
        {/* Main Sidebar */}
     
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
          <div className="side-body padding-top">
            <div className="container-fluid">
              <ul className="nav nav-tabs mobile_responsive user-nav">
                <li
                  className={`${
                    activeList === 0 ? "active1" : ""
                  } cursor-pointer`}
                  onClick={() => setActiveList(0)}
                >
                  <a
                    href="/admin/users"
                    className="active text-black"
                    // style={{ pointerEvents: "none" }}
                  >
                    Child  Users
                  </a>
                </li>
              </ul>
              <div className="d-flex flex-wrap justify-content-between me-3">
                <h1 className="page-title">
                  <i className="sidebar-mini-person" /> Child Users
                </h1>
                <div className="d-flex gap-2 pull-right topright_buttons">
                {/* <Link href="##" className={`btn btn-success getsportsetting red_btn ${permit.includes('Add Admin')? "d-block": "d-none"}`} onClick={(e) => {
                    e.preventDefault();  // ✅ Prevents reload
                    handleModal('add-admin', null);  // ✅ Triggers modal
                  }}><i className="fa fa-plus" />
                  Add Admin</Link> */}
                  {/* <Link
                    title="A/c Chips In/Out"
                    href="##"
                    className={`btn btn-sm btn-info color-1 ${permit.includes('A/C chips In/Out')? "d-block": "d-none"}`}
                    onClick={(e) => {
                      e.preventDefault(); // ✅ Prevents reload
                      handleModal("chips-in-out", null); // ✅ Triggers modal
                    }}
                  >
                    A/c Chips In/Out [Super Admin]
                  </Link> */}
                  {/* <Link href="#" className="btn btn-danger getbalancesheet">
                    <i className="fa fa-file" /> Export
                  </Link> */}
                </div>
              </div>
            </div>
            <div id="sidebar-mini-notifications" />
            <div className="page-content browse container-fluid">
              <div className="alerts"></div>
              <div className="row me-0">
                <div className="col-md-12 oneonofftab">
                  <div className="panel panel-bordered sportsNew">
                    <div className="panel-body">
                      <table className="table table-hover dataTableuser table-responsive user-outer">
                      <thead>
                      <tr>
                        <th>Available Balance</th>
                        <th>Amount</th>
                        <th>Debit/Credit</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{money}</td>
                        <td>{hist?.amount}</td>
                        <td>{hist?.type}</td>
                      </tr>

                    </tbody>
                      </table>
                      <form
                        method="get"
                        className="form-search add-users-outer"
                      >
                        <div id="search-input" className="bot_pdenew">
                          <select
                            id="search_key"
                            name="key"
                            data-select2-id="search_key"
                            className="select2-hidden-accessible"
                            aria-hidden="true"
                          >
                            <option value="id" data-select2-id={2}>
                              Id
                            </option>
                            <option value="role_id">Role Id</option>
                            <option value="parent_id">Parent Id</option>
                            <option value="super_admin_id">
                              Super Admin Id
                            </option>
                            <option value="admin_id">Admin Id</option>
                            <option value="super_id">Super Id</option>
                            <option value="master_id">Master Id</option>
                            <option value="agent_id">Agent Id</option>
                            <option value="slug">Slug</option>
                            <option value="user_name">User Name</option>
                            <option value="name">Name</option>
                            <option value="email">Email</option>
                            <option value="mobile">Mobile</option>
                            <option value="avatar">Avatar</option>
                            <option value="email_verified_at">
                              Email Verified At
                            </option>
                            <option value="password">Password</option>
                            <option value="impersonate_password">
                              Impersonate Password
                            </option>
                            <option value="remark">Remark</option>
                            <option value="is_front_user_register">
                              Is Front User Register
                            </option>
                            <option value="self_lock_user">
                              Self Lock User
                            </option>
                            <option value="parent_lock_user">
                              Parent Lock User
                            </option>
                            <option value="self_lock_betting">
                              Self Lock Betting
                            </option>
                            <option value="parent_lock_betting">
                              Parent Lock Betting
                            </option>
                            <option value="self_lock_fancy_bet">
                              Self Lock Fancy Bet
                            </option>
                            <option value="parent_lock_fancy_bet">
                              Parent Lock Fancy Bet
                            </option>
                            <option value="is_online">Is Online</option>
                            <option value="is_change_password">
                              Is Change Password
                            </option>
                            <option value="total_settled_amount">
                              Total Settled Amount
                            </option>
                            <option value="self_close_account">
                              Self Close Account
                            </option>
                            <option value="parent_close_account">
                              Parent Close Account
                            </option>
                            <option value="liability">Liability</option>
                            <option value="balance">Balance</option>
                            <option value="profit_loss">Profit Loss</option>
                            <option value="freechips">Freechips</option>
                            <option value="chip">Chip</option>
                            <option value="session_liability">
                              Session Liability
                            </option>
                            <option value="un_match_liability">
                              Un Match Liability
                            </option>
                            <option value="match_stack">Match Stack</option>
                            <option value="one_click">One Click</option>
                            <option value="is_confirm_bets">
                              Is Confirm Bets
                            </option>
                            <option value="time_zone">Time Zone</option>
                            <option value="timezone_value">
                              Timezone Value
                            </option>
                            <option value="create_no_of_child">
                              Create No Of Child
                            </option>
                            <option value="remember_token">
                              Remember Token
                            </option>
                            <option value="settings">Settings</option>
                            <option value="child_user_count">
                              Child User Count
                            </option>
                            <option value="device_id">Device Id</option>
                            <option value="created_by">Created By</option>
                            <option value="created_ip">Created Ip</option>
                            <option value="created_at">Created At</option>
                            <option value="updated_at">Updated At</option>
                            <option value="updated_by">Updated By</option>
                            <option value="last_session">Last Session</option>
                            <option value="user_front_menaul">
                              User Front Menaul
                            </option>
                            <option value="register_user_status">
                              Register User Status
                            </option>
                            <option value="invalid_activites">
                              Invalid Activites
                            </option>
                            <option value="ezugi">Ezugi</option>
                            <option value="is_rules_displayed">
                              Is Rules Displayed
                            </option>
                            <option value="allparents">Allparents</option>
                            <option value="profile_password">
                              Profile Password
                            </option>
                            <option value="last_login">Last Login</option>
                            <option value="state">State</option>
                            <option value="city">City</option>
                            <option value="device_type">Device Type</option>
                            <option value="domain_id">Domain Id</option>
                          </select>
                          {/* <span className="select2 select2-container select2-container--default" dir="ltr" data-select2-id={1} style={{ width: '173.6px' }}><span className="selection"><span className="select2-selection select2-selection--single" aria-haspopup="true" aria-expanded="false" tabIndex={0} aria-disabled="false" aria-labelledby="select2-search_key-container"><span className="select2-selection_rendered" id="select2-search_key-container" role="textbox" aria-readonly="true" title="Id">Id</span><span className="select2-selection_arrow" role="presentation"><b role="presentation" /></span></span></span><span className="dropdown-wrapper" aria-hidden="true" /></span>
                      <select id="filter" name="filter" data-select2-id="filter" tabIndex={-1} className="select2-hidden-accessible" aria-hidden="true">
                        <option value="contains" data-select2-id={4}>contains</option>
                        <option value="equals">=</option>
                      </select> */}
                          <div className="input-group col-md-12 newsearch2">
                            <div className="input-group col-md-2 borderClass">
                              <input
                                type="text"
                                id="myInput"
                                className="form-control"
                                placeholder="Search using invite"
                                onChange={handleChange}
                                name="s"
                              />
                            </div>
                            {/* <div className="input-group col-md-2 borderClass">
                          <select id name="userLock" className="select_opt" data-select2-id={5} tabIndex={-1} aria-hidden="true">
                            <option value selected="selected" data-select2-id={7}>--User Locked--</option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                          </select>
                        </div>
                        <div className="input-group col-md-2 borderClass">
                          <select id name="fancyLock" className="select_opt" data-select2-id={8} tabIndex={-1} aria-hidden="true">
                            <option value selected="selected" data-select2-id={10}>--Fancy Locked--</option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                          </select>
                        </div>
                        <div className="input-group col-md-2 borderClass">
                          <select id name="bettingLock" className="select_opt" data-select2-id={11} tabIndex={-1} aria-hidden="true">
                            <option value selected="selected" data-select2-id={13}>--Betting Locked--</option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                          </select>
                        </div>
                        <div className="input-group col-md-2 borderClass">
                          <select id name="closeAccount" className="select_opt" data-select2-id={14} tabIndex={-1} aria-hidden="true">
                            <option value selected="selected" data-select2-id={16}>--Closed Account--</option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                          </select>
                        </div> */}
                            <div className="d-flex gap-4">
                              <input
                                type="button"
                                className="btn btn-primary btn-lg search p-1"
                                defaultValue="Search"
                              />
                              <button
                                type="button"
                                onClick={handleRefresh}
                                className="btn btn-lg search p-1"
                              >
                                Refresh
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="dataTable mt-5">
                      <table
                        id="dataTable"
                        className="table table-hover dataTableuser table-responsive user-outer"
                    >
                        <thead  className="text-nowrap">
                        <tr>
                            <th className="table-bg">
                            <Link href="#">ID</Link>
                            </th>
                            <th className="table-bg">
                            <Link href="#">User Name</Link>
                            </th>
                            <th className="table-bg">
                            <Link href="#">Mobile Number</Link>
                            </th>
                            {/* <th className="table-bg">
                            <Link href="#">Password</Link>
                            </th> */}
                            <th className="table-bg">
                            <Link href="#">Role</Link>
                            </th>
                            <th className="table-bg">
                            <Link href="#">Main Balance</Link>
                            </th>
                            <th className="table-bg">
                            <Link href="#">Exp</Link>
                            </th>
                            <th className="table-bg">
                            <Link href="#">Bonus</Link>
                            </th>
                            {/* <th className="table-bg">
                            <Link href="#">Commission%</Link>
                            </th>
                            <th className="table-bg">
                            <Link href="#">EXP</Link>
                            </th> */}
                            {/* <th className="table-bg">
                            <Link href="#">Given Commission%</Link>
                            </th> */}
                            {/* <th className="table-bg">
                            <Link href="#"> Settlment Amount</Link>
                            </th> */}
                            <th className="table-bg">
                            <Link href="#">Fancy Locked</Link>
                            </th>
                            <th className="table-bg">
                            <Link href="#">Betting Locked</Link>
                            </th>
                            <th className="table-bg">
                            <Link href="#">User Locked</Link>
                            </th> 
                            {/* <th className="table-bg">
                            <Link href="#">Closed Account</Link>
                            </th> */}
                            <th className="table-bg">
                            <Link href="#">Created by this code</Link>
                            </th>
                            <th className="table-bg">
                            <Link href="#">self code </Link>
                            </th>
                            <th className="table-bg">
                            <Link href="#">Profit Loss</Link>
                            </th>
                            <th className="table-bg">
                            <Link href="#">Created At</Link>
                            </th>
                            <th className="table-bg">
                            <Link href="#">Options</Link>
                            </th>
                            <th className={`table-bg ${permit.includes("View More/Edit")? '':'d-none'}`}>Actions</th>
                        </tr>
                        </thead>
                        <tbody className="admindata">
                        {users?.map(
                            (data) =>
                             (
                                <tr key={data.id}>
                                <td className="pdl0pdr0 border">
                                    <span>{data.id}</span>
                                </td>
                                <td className="pdl0pdr0 border" onClick={() => {
                                  if (data.role !== "user") {
                                    navigate(`/admin/getChildUsers/${data.code}`);
                                  }
                                }}>
                                    <Link
                                    href="#"
                                    title="View Child User"
                                    style={{ color: "#000" }}
                                    >
                                    {data.username}
                                    </Link>
                                </td>
                                <td className="pdl0pdr0 border" onClick={() => {
                                  if (data.role !== "user") {
                                    navigate(`/admin/getChildUsers/${data.code}`);
                                  }
                                }}>
                                    <span>{data.phone}</span>
                                </td>
                                {/* <td className="pdl0pdr0 border">
                                    <span>{data.plain_password}</span>
                                </td> */}
                                <td className="pdl0pdr0 border">
                                    <span>{data.role}</span>
                                </td>
                                <td className="pdl0pdr0 border">{data.money}</td>
                                <td className="pdl0pdr0 border cursor-pointer"
                                  onClick={()=>{
                                    if(data.role === 'user'){
                                      navigate(`/admin/exposure/${data.phone}`)
                                    }
                                  }}
                                >{data.role === 'user' ? data.ownAmount || 0 : data.downlineAmount || 0}</td>
                                <td className="pdl0pdr0 border">
                                    <span className="green">
                                    {data.bonus_money}
                                    </span>
                                </td>
                                {/* <td className="pdl0pdr0 border">
                                    <span className="green">{data.commission}</span>
                                </td>
                                <td className="pdl0pdr0 border ">
                                    <span className="green">{data.givecommission}</span>
                                </td>
                                <td className="pdl0pdr0 border">
                                    <span className="green">0.00</span>
                                </td> */}
                                    <td className="pdl0pdr0 border text-center px-3">
                                    <div className="form-row customtoggle">
                                    <div
                                        className="form-group"
                                        style={{ position: "relative" }}
                                    >
                                        <label
                                        htmlFor="lockuser"
                                        title="Self Lock"
                                        >
                                        {" "}
                                        Fancy Lock
                                        </label>
                                        <div className="toggle_bx">
                                        <label className="switch">
                                            <input
                                            type="checkbox"
                                            name="lock_fancy_betting"
                                            id={data.id_user}
                                            value="1"
                                            defaultChecked={
                                                data.fancylocked === 2
                                            }
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                const newStatus = isChecked ? 2 : 1;
                                                toggleLockFancy(newStatus, data.id_user);
                                            }}
                                            />
                                            <div className="slider round extratoggle" />
                                        </label>
                                        </div>
                                    </div>
                                    </div>
                                    
                                </td>
                                <td className="pdl0pdr0 border text-center px-3">
                                    <div className="form-row customtoggle">
                                    <div
                                        className="form-group"
                                        style={{ position: "relative" }}
                                    >
                                        <label
                                        htmlFor="lockuser"
                                        title="Self Lock"
                                        >
                                        {" "}
                                        Bet Lock
                                        </label>
                                        <div className="toggle_bx">
                                        <label className="switch">
                                            <input
                                            type="checkbox"
                                            name="lock_betting"
                                            id={data.id_user}
                                            value="1"
                                            defaultChecked={
                                                data.betlock === 1
                                            }
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                const newStatus = isChecked ? 1 : 0;
                                                toggleLockBet(newStatus, data.id_user);
                                            }}
                                            />
                                            <div className="slider round extratoggle" />
                                        </label>
                                        </div>
                                    </div>
                                    </div>
                                    
                                </td>
                                <td className="pdl0pdr0 border">
                                    <div className="form-row customtoggle">
                                    <div
                                        className="form-group"
                                        style={{ position: "relative" }}
                                    >
                                        <label
                                        htmlFor="lockuser"
                                        title="Self Lock"
                                        >
                                        {" "}
                                        Self Lock
                                        </label>
                                        <div className="toggle_bx">
                                        <label className="switch">
                                            <input
                                            type="checkbox"
                                            name="close_account"
                                            id={data.id_user}
                                            value="1"
                                            defaultChecked={data.status === 2}
                                            onChange={() => toggleLockUser(data.status, data.id_user)}
                                            />
                                            <div className="slider round extratoggle" />
                                        </label>
                                        </div>
                                    </div>
                                    </div>

                                </td>
                                <td className="pdl0pdr0 border">{data.invite}</td>
                                <td className="pdl0pdr0 border">{data.code}</td>
                                <td className="pdl0pdr0 border">0.00</td>
                                <td className="pdl0pdr0 border">
                                    {timerJoin(data.time)}
                                </td>
                                <td  className="pdl0pdr0 border" >
                                    <div className="d-flex gap-1 ">
                                        <Link to={`/admin/userSetting/${data.phone}`} title="Setting" className="optionsBtn">S</Link>
                                        <Link to={`/admin/userBetHistory/${data.phone}`} title="Bet History" className="optionsBtn">BH</Link>
                                        <Link to={`/admin/userSportsSetting/${data.phone}`} title="Sports Setting" className="optionsBtn">SS</Link>
                                        <Link to={`/admin/userStatement/${data.id}`} title="Account Statement" className="optionsBtn">AS</Link>
                                        <Link to={`/admin/userWeeklyReport/${data.phone}`} title="Weekly Report User" className="optionsBtn">WR</Link>


                                        {/* <Link to={`/admin/userSetting/${data.phone}`} title="Casino Setting" className="optionsBtn">CS</Link>
                                        <Link to={`/admin/userSetting/${data.phone}`} title="I Casino Setting" className="optionsBtn">ICS</Link> */}




                                    </div>
                                </td>
                                <td
                                    className={`  no-sort no-click ${permit.includes("View More/Edit")? 'd-block':'d-none'}`}
                                    id="bread-actions"
                                >
                                    <span className="dropdown user-more-btn">
                                    <Link
                                        href="#"
                                        className="btn btn-xs btn-success"
                                        onClick={(e) => {
                                        e.preventDefault();
                                        handleModal("user-show", data.id);
                                        }}
                                    >
                                        View More <span className="caret" />
                                    </Link>
                                    </span>
                                </td>
                                </tr>
                            )
                        )}
                        </tbody>
                    </table>
                     
                      <div className="pull-right"> </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal modal-danger fade"
            tabIndex={-1}
            id="delete_modal"
            role="dialog"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <h4 className="modal-title">
                    <i className="sidebar-mini-trash" /> Are you sure you want
                    to delete this user?
                  </h4>
                </div>
                <div className="modal-footer">
                  <form action="#" id="delete_form" method="POST">
                    <input type="hidden" name="_method" defaultValue="DELETE" />
                    <input
                      type="hidden"
                      name="_token"
                      defaultValue="DoQ41U4J92ipYmOflRWNVPRcNW09QmRFKMZpxtme"
                    />
                    <input
                      type="submit"
                      className="btn btn-danger pull-right delete-confirm"
                      defaultValue="Yes, Delete it!"
                    />
                  </form>
                  <button
                    type="button"
                    className="btn btn-default pull-right"
                    data-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div id="myModal" className="modal fade" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal">
                    ×
                  </button>
                  <h4 className="modal-title">Password</h4>
                </div>
                <div className="modal-body">
                  <label>Password</label>
                  <input
                    type="hidden"
                    name="userid"
                    className="userid"
                    defaultValue
                  />
                  <input
                    type="hidden"
                    name="mono"
                    id="mono"
              
                  />
                  <input
                    type="password"
                    name="password"
                    id="password"
                    className="form-control"
                    placeholder="Please enter password"
                  />
                  <div id="errormsg" />
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    id="checkpassword"
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            id="myModal"
            className="modal fade in"
            role="dialog"
            style={{ paddingRight: 17 }}
          >
            <div className="modal-dialog">
              {/* Modal content*/}
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal">
                    ×
                  </button>
                  <h4 className="modal-title">Password</h4>
                </div>
                <div className="modal-body">
                  <label>Password</label>
                  <input
                    type="hidden"
                    name="userid"
                    id="userid"
                    defaultValue="eyJpdiI6IkV0UkpTM2NpcEFYV1AyT1JJTDVoUVE9PSIsInZhbHVlIjoiVU10TkplYzNsZjd4T0E1MUNBa1RLZz09IiwibWFjIjoiMDY5MmE5YTRjNWE1MTYwMGUxNzc2NmNkMjQzMGJjOTczM2ZkNDg2ZTU0ZGY1NzJkNmY5ZWU0NDE4ZjljZGRlMCJ9"
                  />
                  <input
                    type="password"
                    name="password"
                    id="password"
                    className="form-control"
                    placeholder="Please enter password"
                  />
                  <div id="errormsg" />
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    id="checkpassword"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AdminModal modal={modal} setModal={setModal} data={users} />
        {
          <div
            id="overlayId"
            className={`overlay ${modal?.action ? "d-block" : "d-none"}`}
          ></div>
        }
      </div>
    </>
  );
};
export default ChildUsers;